import { AppForm } from '../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';

@Injectable()
export class ExecutionOfTrafficOrganizationProjectsForm extends AppForm {

  constructor() {
    super({
      projectType: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      applicationSubject: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      geometry: new FormControl(null, Validators.required)
    });
  }

  public get projectType(): FormControl {
    return this.get('projectType') as FormControl;
  }

  public get applicationSubject(): FormControl {
    return this.get('applicationSubject') as FormControl;
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  public override patchFormValues(app: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues(app);
    if (app.porId) {
      this.applicationSubject.disable();
      this.projectType.disable();
    } else {
      this.applicationSubject.enable();
      this.projectType.enable();
    }
  }

}
